




















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import SubHeader from "@/components/SubHeader.vue";
import requestService from "@/service/requestService";
import InspectionDetailContent from "@/components/InspectionDetailContent.vue";
import { deepCopy } from "@/service/util";
import { Action, Getter } from "vuex-class";
import vuedraggable from "vuedraggable";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { InspectDetail } from "@/model/InspectDetail";
import { MESSAGE } from "@/model/Message";

@Component({
  components: {
    Header,
    SubHeader,
    InspectionDetailContent,
    draggable: vuedraggable,
    ConfirmDialog
  }
})
export default class InspectionDetail extends Vue {
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  reqService: any;
  showEditSeibiMenu: boolean = false;

  keywordSeibiMenu1: string = "";
  keywordSeibiMenu2: string = "";

  chkAllSeibiMenu1: boolean = false;
  chkAllSeibiMenu2: boolean = false;

  listSeibiMenu: any = [];
  listStagingSeibiMenu: any = [];
  listStagingSelectedSeibiMenu: any = [];
  listSelectedSeibiMenu: any = [];
  listDataSeibiMenu: any = [];
  isRestart: boolean = false;

  $refs!: {
    inspectionDetail: InspectionDetailContent;
    cancelDialog: ConfirmDialog;
    errorDialog: ConfirmDialog;
  };

  @Action("restoreState", { namespace: "ReservationDetail" })
  restoreState: any;
  @Action("setShakenShurui", { namespace: "InspectionDetail" })
  setShakenShurui: any;

  /** 2021-10-12 sh #7467 it does not check if jizen does not use. [START] */
  @Getter("isCanJizenMitsumori", { namespace: "FunctionSetting" })
  isCanJizenMitsumori: any;
  /** 2021-10-12 sh #7467 it does not check if jizen does not use. [END] */

  created() {
    this.restoreState();
    this.reqService = new requestService();
    this.getWorkProgressState();
  }

  getShakenShurui() {
    this.reqService.getSeibiMenuList().then(
      (res: any[]) => {
        if (res) {
          this.$set(this, "listSelectedSeibiMenu", deepCopy(res));
          this.$set(this, "listDataSeibiMenu", deepCopy(res));
        }

        this.$set(this, "shakenShurui", res);
        this.setShakenShurui(res);
      },
      (err: any) => {
        this.$set(this, "listSelectedSeibiMenu", []);
        this.$set(this, "listDataSeibiMenu", []);
        this.$set(this, "shakenShurui", []);
        this.setShakenShurui([]);
      }
    );
  }

  async showSeibiMenuDialog() {
    this.showEditSeibiMenu = true;
    this.getShakenShurui();
    const res = await this.reqService.getSeibiMenuListMaster();
    if (res) {
      this.listSeibiMenu = res;
    }
  }

  onCloseDialog() {
    this.showEditSeibiMenu = false;
  }

  getSaveObj() {
    const menuList = this.listSelectedSeibiMenu.map((e: any, i: number) => {
      return { ...e, displayOrder: i };
    });
    const listSelected = this.listSelectedSeibiMenu.map(
      (e: any) => e.seibiMenuCd
    );
    const menuDeleteList = this.listDataSeibiMenu.filter(
      (e: any, i: number) => listSelected.indexOf(e.seibiMenuCd) == -1
    );
    return { menuList, menuDeleteList };
  }

  onSave() {
    this.reqService.saveSeibiMenu(this.getSaveObj()).then(() => {
      this.$refs.inspectionDetail.callBackSaveSeibiMenu();
    });
    this.showEditSeibiMenu = false;
  }

  saveOrderRows() {
    console.log(this.getSaveObj());
  }

  setSelectedSeibiMenu() {
    const list = deepCopy(this.listStagingSeibiMenu);
    this.listSelectedSeibiMenu = [...this.listSelectedSeibiMenu, ...list];
    this.listStagingSeibiMenu = [];
  }

  removeSelectedSeibiMenu() {
    if (this.listStagingSelectedSeibiMenu.length > 0) {
      let arrIndexDelete = this.listStagingSelectedSeibiMenu.map((e: any) =>
        this.listSelectedSeibiMenu.findIndex(
          (item: any) => e.seibiMenuCd == item.seibiMenuCd
        )
      );
      arrIndexDelete = arrIndexDelete.sort().reverse();
      arrIndexDelete.forEach((index: number) => {
        this.listSelectedSeibiMenu.splice(index, 1);
      });
      this.listStagingSelectedSeibiMenu = [];
    }
  }

  get listSeibiMenuDisplay() {
    if (this.listSeibiMenu.length > 0) {
      let res = this.listSeibiMenu.filter(
        (item: any) => JSON.stringify(item).indexOf(this.keywordSeibiMenu1) > -1
      );
      if (this.listSelectedSeibiMenu.length > 0) {
        return res.filter((item: any) => {
          return (
            this.listSelectedSeibiMenu.findIndex(
              (e: any) => e.seibiMenuCd === item.seibiMenuCd
            ) === -1
          );
        });
      }
      return res;
    }
    return [];
  }

  isSelectedCheckbox(seibiMenuCd: string, list: any) {
    return list.findIndex((e: any) => e.seibiMenuCd === seibiMenuCd) > -1
      ? "is-checked"
      : "";
  }

  @Watch("listStagingSelectedSeibiMenu")
  onChangeChRight() {
    if (
      this.listStagingSelectedSeibiMenu.length !== 0 &&
      this.listStagingSelectedSeibiMenu.length ===
        this.listSelectedSeibiMenu.length
    ) {
      this.chkAllSeibiMenu2 = true;
    } else {
      this.chkAllSeibiMenu2 = false;
    }
  }

  onClickChAllRight() {
    if (this.chkAllSeibiMenu2) {
      this.listStagingSelectedSeibiMenu = [...this.listSelectedSeibiMenu];
    } else if (!this.chkAllSeibiMenu2) {
      this.listStagingSelectedSeibiMenu = [];
    }
  }

  @Watch("listStagingSeibiMenu")
  onChangeChLeft() {
    if (
      this.listStagingSeibiMenu.length !== 0 &&
      this.listStagingSeibiMenu.length === this.listSeibiMenuDisplay.length
    ) {
      this.chkAllSeibiMenu1 = true;
    } else {
      this.chkAllSeibiMenu1 = false;
    }
  }

  onClickChAllLeft() {
    if (this.chkAllSeibiMenu1) {
      this.listStagingSeibiMenu = [...this.listSeibiMenuDisplay];
    } else if (!this.chkAllSeibiMenu1) {
      this.listStagingSeibiMenu = [];
    }
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => {
      this.$router.push({ name: "reservation" });
    });
  }

  loading: boolean = false;
  inspectionDetail: InspectDetail = {
    kensain: [],
    seibishi: [],
    hojoSeibishi: []
  };
  errorMsg: string = "";
  disabledStart: boolean = true;
  startInspect() {
    this.loading = true;
    this.$refs.inspectionDetail.setInspectDetail();
    /** 2021-10-12 sh #7467 it does not check if jizen does not use. [START] */
    // this.reqService.saveInsectionDetail(this.inspectionDetail).then(
    let saveData = deepCopy(this.inspectionDetail);
    if (!this.isCanJizenMitsumori) {
      saveData.jizenCd = 0; // 1:事前見積有効 0 :事前見積無効 null:設定更新しない
    }
    this.reqService.saveInsectionDetail(saveData).then(
    /** 2021-10-12 sh #7467 it does not check if jizen does not use. [END] */
      (res: any) => {
        this.$refs.inspectionDetail.save();
        /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
        this.$refs.inspectionDetail.updateInsectionDetail(res);
        /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
        this.reqService.postNavigtion(this.uketsukeExtendsId);
        if (!this.isRestart) {
          let inspectionDetail: InspectDetail = {
            kensain: []
            , seibishi: []
            , hojoSeibishi: []
            , uketsukeExtendId: this.uketsukeExtendsId
          };
          this.reqService.updateUketsukeExtendsNyuukoYmd(inspectionDetail).then(
            (res: any) => {
              this.$router.push({ name: "carselection" });
            }
          );
        } else {
        this.$router.push({ name: "carselection" });
        }
      },
      (res: any) => {
        this.loading = false;
        if (res.status < 500 && res.rsltComment) {
          this.errorMsg = res.rsltComment;
        } else {
          this.errorMsg = MESSAGE.SystemError;
        }
        this.$refs.errorDialog.onOpen();
      }
    );
  }
  setDisabledStart(val: boolean) {
    this.disabledStart = val;
  }
  setInspectionDetail(val: InspectDetail) {
    this.inspectionDetail = val;
  }
  getWorkProgressState() {
    this.reqService.getSubHeaderData(this.uketsukeExtendsId, this.$route.meta).then(
      (res: any) => {
        if (res.sknWorkProgressStateId && res.sknWorkProgressStateId > 0) {
          this.isRestart = true;
        }
      },
      (err: any) => {}
    );
  }
}
